import React, { useState } from "react";
import Footer from "../landingPage/footer";
import "./AICreator.scss";
import FileConstants from "../../FileConstants";
import TextConstants from "../../TextConstants";
import MetaTagContents from "../../MetaTagContents";
import NavBar from "../landingPage/header/navbar";
import { Tabs, Row, Col, Card, Modal, Button, Carousel, Select, Collapse, Layout } from "antd";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import AICreatorContext from "../../contexts/AICreatorContext";
import SignUpModal from "./SignUpModal";
import AICreatorWeb from "./AICreatorWeb";
import AICreatorMobile from "./AICreatorMobile";
import posthog from "posthog-js";
import { REGISTER_POSTHOG_API_KEY, POSTHOG_API_HOST } from "../../env";

const { Content } = Layout;

const AICreator = () => {
    const [signUpModalVisible, setSignUpModalVisible] = useState(false);
    const [registerPosthog, setRegisterPosthog] = useState(null);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const utmSource = urlParams.get('utm_source');
        const email = urlParams.get('email') || "";

        const phInstance = posthog.init(REGISTER_POSTHOG_API_KEY, {
            api_host: POSTHOG_API_HOST,
            autocapture: false,
            name: "register",
            capture_pageview: false,
            disable_session_recording: true,
            loaded: (ph) => {
                if (utmSource) {
                    ph.register({ utm_source: utmSource });
                }
            },
        });

        setRegisterPosthog(phInstance);

        if (phInstance && utmSource) {
            console.log('utm_source', utmSource);
            console.log('email', email);

            phInstance.capture('ai_creator_page_visit', {
                utm_source: utmSource,
                email: email
            });
        }
    }, []);



    const openSignUpModal = () => {
        setSignUpModalVisible(true);
    }

    const closeSignUpModal = () => {
        setSignUpModalVisible(false);
    }

    return (
        <>
            <NavBar />
            <Layout>
                <AICreatorContext.Provider value={{
                    openSignUpModal: openSignUpModal,
                    closeSignUpModal: closeSignUpModal,
                    signUpModalVisible: signUpModalVisible
                }}>
                    <AICreatorWeb />
                    <AICreatorMobile />
                    <SignUpModal />
                </AICreatorContext.Provider >
            </Layout>
            <Footer />
        </>
    );
}


export default AICreator;
